import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-date-selector',
  templateUrl: './date-selector.component.html',
  styleUrls: ['./date-selector.component.scss'],
})

export class DateSelectorComponent { 

  days: number[] = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31];
  months: string[] = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  years: number[] = [];

  day: number;
  month: string;
  year: number;

  tooHigh: boolean;
  tooLow: boolean;

  _value: Date;
  _required: boolean;
  _min: Date;
  _max: Date;
  _validationErrors: any[];

  validationStatus: string = 'valid';

  @Input() showClear: boolean = true;

  @Input() set min(val: Date){
    this._min = val;
    this.updateYears();
  }

  @Input() set max(val: Date) {
    this._max = val;
    this.updateYears();
  }

  @Input() set validationMessage(val: string){
    this._validationErrors.push({message:val});
  }

  @Input() set required(val: boolean){
    this._required = val;
    this.updateValidationStatus();
  }

  @Input() set value(date: Date){
    if (date){
      const d = new Date(date);
      this.day = d.getDate();
      this.month = this.months[d.getMonth()];
      this.year = d.getFullYear();
      this.setValue(d);
    }
    else{
      this.day = undefined;
      this.month = undefined;
      this.year = undefined;
      this.setValue(undefined);
    }
  }

  @Output() valueChange = new EventEmitter<Date>();

  constructor(){
    this.updateYears();
  }

  updateYears(){
    const currentYear = new Date().getFullYear();
    this.years = [];
    const max = this._max ? this._max.getFullYear() : currentYear;
    const min = this._min ? this._min.getFullYear() : currentYear - 100;    
    for (let i=0; i<(max-min); i++){
      this.years.push(max-i);
    }
    if (this._value){
      if (this.years.indexOf(this._value.getFullYear()) < 0){
        this.years.unshift(this._value.getFullYear());
      }
    }
  }

  onValueChanged(e){
    if (this.day && this.month && this.year){
      const d = this.day;
      const m = this.months.indexOf(this.month);
      const y = this.year;
      setTimeout(() => {
        this.setValue(new Date(Date.UTC(y,m,d)));
        if (!(this.tooHigh || this.tooLow)) {
          this.valueChange.emit(this._value);
        }
      }, 10)
    }
  }

  setValue(value: Date){
    this.tooHigh = (this._max && value) ? value > this._max : false;
    this.tooLow = (this._min && value) ? value < this._min : false;
    if (!(this.tooHigh || this.tooLow)) {
      this._value = value;
    }
    this.updateValidationStatus();
  }

  updateValidationStatus(){
    setTimeout(() => {
      this.validationStatus = (this.tooHigh || this.tooLow || (this._required && (!this._value))) ? 'invalid' : 'valid';
    }, 10);
  }

  clear(){
    this.value = undefined;
    this.valueChange.emit(undefined);
  }
}
